import React from 'react';
import { Link } from 'react-router-dom';
import backgroundImg from '../assets/images/footer-bg.jpg';
import logo from '../assets/images/logo1.jpg';
import { MenuItemsData } from '../routes/NavItems';
import { FaTwitter, FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa'; 

const Footer = () => {
  const socialMediaLinks = [
    // { id: 1, icon: <FaTwitter />, link: 'https://twitter.com' }, // Twitter icon
    // { id: 2, icon: <FaFacebookF />, link: 'https://facebook.com' }, // Facebook icon
    // { id: 3, icon: <FaInstagram />, link: 'https://instagram.com' }, // Instagram icon
    { id: 4, icon: <FaLinkedinIn />, link: 'https://www.linkedin.com/company/duralyze/?lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_companies%3Bb4ok2rLjQAGlSMwtlO%2BN3Q%3D%3D' }, // LinkedIn icon
  ];

  return (
    <footer
      className="bg-cover bg-center text-white py-16"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${backgroundImg})`, 
      }}
    >

      <div className="container mx-auto px-6 sm:px-8 md:px-10 lg:px-20">
        {/* Logo and Description */}
        <div className="flex flex-row justify-center items-center text-center">
          <img src={logo} alt="Duralyze Green energy company logo" className="h-14 md:h-20 w-auto" />
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl">
            Your Trusted Partner in Innovative Solutions
          </h2>
        </div>

        {/* Email */}
        <div className='text-center text-base md:text-lg mt-4 md:mt-6'>
          Email: info@duralyze.com
        </div>

        {/* Menu Items */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 text-center mt-10">
          {MenuItemsData.map((item) => (
            <div key={item.id}>
              <div className={`text-base md:text-lg font-bold mb-2`}>
                {item.title}
              </div>
              <ul className="space-y-1">
                {item.subItems.map((subItem, index) => (
                  <li key={index}>
                    <Link
                      to={subItem.path}
                      className="text-xs md:text-sm transition-all duration-200 hover:text-base md:hover:text-lg"
                    >
                      {subItem.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Social Media */}
        <div className="flex justify-center space-x-4 mt-10">
          {socialMediaLinks.map((social) => (
            <a
              key={social.id}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Open ${social.link} in a new tab`} 
              className="text-lg md:text-2xl hover:text-theme-blue transition-colors"
            >
              {social.icon} {/* Render the React Icon */}
            </a>
          ))}
        </div>

        {/* Copyright */}
        <div className="text-center mt-8">
          <p className="text-sm sm:text-base">
            &copy; {new Date().getFullYear()} Duralyze. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
